var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4525 66H65.76V72H75.4525V66Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.145 75H65.76V81H85.145V75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53.9975H15V59.9975H105V53.9975Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2625 61.7525L31.5275 58.4C29.5075 57.8225 27.6625 56.71 26.1875 55.185C23.2875 52.185 23.29 47.305 26.1875 44.305C27.625 42.8175 29.5425 42 31.5875 42C33.6325 42 35.55 42.8175 36.9875 44.305C37.345 44.6725 37.6775 45.065 37.9825 45.475L38.72 44.7375L43.2625 61.755V61.7525ZM31.5875 48C31.1825 48 30.7975 48.1675 30.5025 48.475C29.8375 49.165 29.8375 50.3275 30.5025 51.0175C31.245 51.7875 32.17 52.345 33.1775 52.6325L34.7375 53.0775L34.265 51.31C33.9775 50.2375 33.4275 49.255 32.6725 48.4725C32.3775 48.1675 31.9925 47.9975 31.5875 47.9975V48Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.725 61.7425L38.8575 46.43C39.6175 43.6125 41.09 41.0325 43.11 38.965C44.9775 37.0525 47.4675 36 50.12 36C52.7725 36 55.2625 37.0525 57.13 38.965C60.9425 42.865 60.9425 49.2125 57.13 53.1125C55.1 55.1875 52.5625 56.7 49.79 57.485L34.7275 61.745L34.725 61.7425ZM50.12 42C49.0975 42 48.13 42.4125 47.4 43.1575C46.095 44.4925 45.1425 46.165 44.65 47.9925L43.275 53.0875L48.1575 51.7075C49.925 51.2075 51.5425 50.2425 52.84 48.915C54.3925 47.3275 54.3925 44.745 52.84 43.1575C52.11 42.41 51.145 42 50.12 42Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69V63C31.55 63 36 59.565 36 57H42C42 63.1675 34.71 69 27 69Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32.5275H36V90.6825H42V32.5275Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69C50.3575 69 46.2375 68.0875 42.9775 66.5625C38.4775 64.455 36 61.33 36 57.76H42C42 60.2075 48.3925 63 54 63V69Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99 93H21C16.0375 93 12 88.9625 12 84V36C12 31.0375 16.0375 27 21 27H99C103.963 27 108 31.0375 108 36V84C108 88.9625 103.963 93 99 93ZM21 33C19.345 33 18 34.345 18 36V84C18 85.655 19.345 87 21 87H99C100.655 87 102 85.655 102 84V36C102 34.345 100.655 33 99 33H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/GiftCard.ea397a8b.svg";
export { ForwardRef as ReactComponent };